module.exports = __webpack_public_path__ + "img/myapps.91a5a56.svg";